<template>
  <label :for="id" class>
    <span v-if="number" class="form__label-number">{{ number }}</span>
    <span v-if="label" class="form__label-text">
      <slot>
        <span v-html="label"></span>
      </slot>
      <Icon v-if="required" name="asterisk" />
    </span>
    <BaseControlHelp
      v-if="help"
      :id="id"
      :help="help"
      class="form__label-help"
    />
    <span
      v-if="labelDescription"
      class="form__label-description"
      v-html="labelDescription"
    ></span>
  </label>
</template>

<script>
import BaseControlHelp from "./BaseControlHelp";

export default {
  name: "BaseLabel",
  components: {
    BaseControlHelp
  },
  props: {
    id: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    labelDescription: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ""
    }
  }
};
</script>
